<template>
  <div class="account">
    <h1>Account</h1>

    <div class="card">
      <p><b>Name:</b> {{ user.name }}</p>
      <p><b>Email:</b> {{ user.email }}</p>
      <p><b>User ID:</b> {{ user.uid }}</p>

      <a @click="showChangePassword = !showChangePassword">Change password</a><br><br>

      <change-password @changedPassword="showChangePassword = false" v-show="showChangePassword" />

      <a @click="logout">Log out</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ChangePassword from './ChangePassword';

export default {
  components: {
    ChangePassword,
  },

  data() {
    return {
      showChangePassword: false,
    };
  },

  computed: {
    ...mapState({
      user: ({ auth }) => auth.user,
    }),
  },

  methods: {
    logout() {
      this.$confirm({ title: 'Logout', message: 'Are you sure you want to logout?' })
        .then(() => {
          this.$firebase.auth().signOut()
            .then(() => {
              this.$router.replace('login');
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  .account {
    @include container;
  }
</style>
